import type { RootState } from "~/app/store";
import { selectLineItem } from "~/features/cart/cart/redux/selectors/cartSelectors";
import { getPackageCode } from "~/utils/cartHelper";
import { getProductData, type ProductData } from "~/domains/product/types/ProductData";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import type { LineItem } from "~/features/cart/cart/models/CartData";

export function isProductEntryFcc(lineItems: LineItem[], productDescriptor: ProductDescriptor): boolean {
  const fccPackageCodes = getFccPackCodes(productDescriptor.base);
  return lineItems.some((item) => fccPackageCodes.includes(item.packCode));
}

function getFccPackCodes(product: ProductData | ProductDescriptor) {
  const productData = getProductData(product);
  return Object.values(productData.fifteenDigit)
    .filter((val) => val?.isFcc)
    .map((val) => getPackageCode(val.materialNo));
}

// Legacy shim: used by productEntryHelper consumers that pass a lineItem id
export const selectLineItemById =
  (id: number) =>
  (state: RootState): LineItem =>
    selectLineItem(id)(state);
